<template>
  <span>
    <span v-if="human"
          class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
      {{ pre }}{{ human }}
    </span>
  </span>
</template>

<script>
export default {
  props: {
    end: {  // pass date object till when you want to run the timer
      type: String,
      required: true,
    },
    negative: {  // optional, should countdown after 0 to negative
      type: Boolean,
      default: true
    },
    pre: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      now: new Date(),
      timer: null,
      counter: 30,
    }
  },
  setup(props) {
    const sessionEnd = new Date(props.end);
    return {
      sessionEnd
    }
  },
  computed: {

    human() {
      let day = '';

      if (this.seconds < 0) {
        if (this.seconds > -60) {
          return 'Started ' + Math.abs(this.seconds) + ' seconds ago';
        }
        if (this.seconds > -120) {
          return this.min + ' minute ' + this.sec + ' seconds ago';
        }
        if (this.seconds > -900) {
          return this.min + ' minutes ' + this.sec + ' seconds ago';
        }

        return '';
      }

      if (this.day > 31) {
        return 'More than 1 month away';
      }
      if (this.day === 1) {
        day = '1 day ';
      }
      if (this.day > 1) {
        day = this.day + 'days ';
      }
      if (day === '' && this.hour === 0) {
        return this.min + 'm ' + this.sec + 's';
      }
      return day + this.hour + 'h ' + this.min + 'm ' + this.sec + 's';
    },

    day() {
      return Math.trunc((Math.abs(this.sessionEnd - this.now)) / 1000 / 86400);
      //return d > 0 ? d + 'days' : '';
    },
    hour() {
      return Math.trunc((Math.abs(this.sessionEnd - this.now)) / 1000 / 3600) % 24;
      //return h > 9 ? h : '0' + h;
    },
    min() {
      return Math.trunc((Math.abs(this.sessionEnd - this.now)) / 1000 / 60) % 60;
      //return m > 9 ? m : '0' + m;
    },
    sec() {
      return Math.trunc((Math.abs(this.sessionEnd - this.now)) / 1000) % 60
      //return s > 9 ? s : '0' + s;
    },
    seconds() {
      return Math.trunc((this.sessionEnd - this.now) / 1000);
    },
    classObject() {
      return 'inline-flex px-4 py-1 rounded-full text-sm ' +
          'font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600';
    },
  },

  // https://stackoverflow.com/questions/55773602/how-do-i-create-a-simple-10-seconds-countdown-in-vue-js

  watch: {
    now: {
      immediate: true,
      handler(newVal) {
        //console.log(newVal);
        this.timer = setTimeout(() => {
          this.now = new Date();
        }, 1000)
      }
    },

  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>

</style>